import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

require('./fontawesome');

Vue.config.productionTip = false

// MapBox
import VueMapbox from 'vue-mapbox'
import Mapbox from 'mapbox-gl'
Vue.use(VueMapbox, { mapboxgl: Mapbox })

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
